class ZenError {
  static TokenExpired = 'jwt expired';
}

export default ZenError;
